module.exports = __webpack_public_path__ + "img/device_fan_e.b4daa292.png";